import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import io from 'socket.io-client';
import Store from './Store';

export const socket = io(window.location.origin, {
  path: '/ws',
  auth: { key: Store.state.user.jwt },
  autoConnect: !!Store.state.user.jwt,
  transports: ['websocket'],
  secure: window.location.protocol === 'https:',
});

Vue.use(new VueSocketIO({
  debug: process.env.NODE_ENV === 'development',
  connection: socket,
  vuex: {
    store: Store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_',
  },
}));
